import {Divider} from '@/components/ui/divider/Divider'
import {ProjectFormNewProjectSection} from '@/features/projects/components/project-form/project-form-new-project-section/ProjectFormNewProjectSection'
import {ProjectFormPatientSection} from '@/features/projects/components/project-form/project-form-patient-section/ProjectFormPatientSection'
import {ProjectFormReferenceSection} from '@/features/projects/components/project-form/project-form-reference-section/ProjectFormReferenceSection'
import {ProjectFormReferringSpecialistSection} from '@/features/projects/components/project-form/project-form-referring-specialist-section/ProjectFormReferringSpecialistSection'

export const TransformProjectFormSections = ({canBeTransformed}: {canBeTransformed: boolean}) => {
    return (
        <>
            <ProjectFormPatientSection showPatientSelect={false} />
            <Divider direction="horizontal" />
            <ProjectFormReferenceSection isAllowed={canBeTransformed} editingOperation="transform" />
            {canBeTransformed && (
                <>
                    <Divider direction="horizontal" />
                    <ProjectFormNewProjectSection editingOperation="transform" />
                    <Divider direction="horizontal" />
                    <ProjectFormReferringSpecialistSection />
                </>
            )}
        </>
    )
}
